import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=7dd05bd7&scoped=true&"
import script from "./ChangeStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatus.vue?vue&type=style&index=0&id=7dd05bd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd05bd7",
  null
  
)

export default component.exports